import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router"

export const Route = createFileRoute("/terms-and-conditions")({
  staticData: { title: "Terms and Conditions" },
  component: lazyRouteComponent(
    () => import("#pages/legal/terms-and-conditions.tsx"),
    "TermsAndConditions",
  ),
})
